@if (calendarIntervals?.length) {
    <ms-calendar-item-list [calendarIntervals]="calendarIntervals" [location]="timeFrameLocation"></ms-calendar-item-list>
}
